import { render, staticRenderFns } from "./QuotesHome.vue?vue&type=template&id=28853e2b"
import script from "./QuotesHome.vue?vue&type=script&lang=js"
export * from "./QuotesHome.vue?vue&type=script&lang=js"
import style0 from "./QuotesHome.vue?vue&type=style&index=0&id=28853e2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports